var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"powerText2"},[_c('section',{staticClass:"row m-0 lxing"},[_c('img',{staticClass:"banner-img",attrs:{"src":_vm.$t('centerDataImg'),"alt":"数据中心配图"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }